import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { StockVideo } from 'hooks/queries/designer/useStockVideos'
import { useStockVideoDownload } from 'hooks/queries/designer/useStockVideoDownload'
import { insertVideo } from './insertVideo'
import { useCreateMediaObjects } from 'hooks/queries/mediaObjects/useCreateMediaObjects'
import { v4 as uuidv4 } from 'uuid'
import { useRootStore } from 'stores/RootStore'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { getVideoMimeType } from './components/StockVideosGallery'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { reportError } from 'utils/error'

export const useInsertStockVideos = () => {
  const editor = useEditor()
  const { designStore } = useRootStore()
  const createMediaObjects = useCreateMediaObjects()
  const { downloadHighRes } = useStockVideoDownload()

  const handleInsert = async (video: StockVideo) => {
    const frameId = getCurrentFrame(editor).id
    designStore?.setProcessingShapeId(frameId)
    
    try {
      const highResUrl = await downloadHighRes(video.id)
      const videoUrl = highResUrl || video.videos.medium.url
      
      const mimeType = video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url)
      const originalFile = await fetch(videoUrl)
      const blob = await originalFile.blob()
      const file = new File([blob], video.id, { type: mimeType })
      const [, extension] = mimeType.split('/')
      const mediaObjects = await createMediaObjects.mutateAsync([{ filename: `${uuidv4()}.${extension}`, file }])
      const mediaObject = mediaObjects[0]
      insertVideo(editor, {
        id: video.id,
        source_url: mediaObject.source_url,
        mime_type: mimeType,
        width: video.videos.medium.width,
        height: video.videos.medium.height,
        duration: video.duration,
        variants: [],
        thumbnail_url: video.videos.medium.thumbnail,
      })
    } catch (error) {
      showErrorMessageToast('Something went wrong while downloading your video. Please try again.')
      reportError(error)
    } finally {
      designStore?.setProcessingShapeId(undefined)
    }
  }

  return { handleInsert }
}
